export const initialState = {
  cashbackList: [],
  cashbackCount: 0,
  skip: 0,
  limit: 20,
  currentPage: 0,
  itemsOnPage: 10,
  actionProcessing: false,
  error: null,
};
